module.exports = {
    EMAIL_SUBJECTLINE_KEY: [{
        "title": "Real Time Notices",
        children: [{
            field: "locationEdit",
            label: "Location edit"
        },
        {
            field: "realTimeNew",
            label: "Real time new"
        },
        {
            field: "realTimeUpdated",
            label: "Real time updated"
        }, {
            field: "realTimeImage",
            label: "Real time image"
        }
        ],
    }, {
        "title": "Scheduled Reports",
        children: [{
            field: "reviewReport",
            label: "Review report"
        },
        {
            field: "qAReport",
            label: "QA-report"
        },
        {
            field: "dashboardReport",
            label: "Dashboard Report"
        },
        {
            field: "googleSuggestedEditReport",
            label: "Google Suggested Edits Report"
        },
        {
            field: "googleSuggestedEditNotification",
            label: "Google Suggested Edit Notification"
        },
    ]
    }, {
        "title": "Report Downloads",
        children: [{
            field: "localPost",
            label: "localPost"
        },
        {
            field: "locationAudit",
            label: "Location audit"
        },
        {
            field: "localPostDetail",
            label: "LocalPost detail"
        },
        {
            field: "locationDetail",
            label: "Location detail"
        },
        {
            field: "filterTag",
            label: "Filter tag"
        },
        {
            field: "reviewDownload",
            label: "Review download"
        },
        {
            field: "qaDownload",
            label: "QA Download"
        }
    ]
    }, {
        title: "ReviewsInbox Communication",
        children: [{
            field: "replyCc",
            label: "ReplyCc"
        },
        {
            field: "externalNote",
            label: "External note"
        }]
    },
    {
        title: "Account Maintenance",
        children: [{
            field: "login",
            label: "Login"
        },
        {
            field: "invite",
            label: "Invite"
        },
        {
            field: "passwordReset",
            label: "Password reset"
        },
        {
            field: "signUp",
            label: "SignUp"
        },
        {
            field: "inviteAccept",
            label: "Accept Invite"
        }]
    }],
    domainCSSControl: [{
        "title": "Left Navigation Color Options",
        children: [{
            field: "sidebarBackground",
            label: "Side Tab Background"
        },
        {
            field: "sidebarBorder",
            label: "Side Tab Border"
        },
        {
            field: "sidebarTransparency",
            label: "Side Tab Transparency"
        }, {
            field: "activeTabList",
            label: "Active Tab"
        }, {
            field: "tabIcon",
            label: "Side tab Icon"
        }, {
            field: "activeIcon",
            label: "Active Icon"
        }],
    },
    {
        "title": "Top Navigation Color Options",
        children: [{
            field: "logoBackground",
            label: "Logo Background"
        },
        {
            field: "headerBackground",
            label: "Header Background"
        },
        {
            field: "headerIcon",
            label: "Header Icon Colors"
        }
        ],
    }
    ]
}

